// Types
import { AltDesignationsCard } from 'components/AltDesignationsCard/AltDesignationsCard';
import _ from 'lodash';
import type { TAltDesignations } from '@timeedit/types/lib/types';
import { TEDrawerSection } from '@timeedit/ui-components';

type tProps = {
  value: any;
  onChangeValue: (newAltDesignation: TAltDesignations[]) => void;
};
export const Language = ({ value, onChangeValue }: tProps) => {
  return (
    <TEDrawerSection label="Language">
      <div className="section-item">
        <AltDesignationsCard
          displayDescription
          altDesignations={value.altDesignations}
          onChange={onChangeValue}
          title="Display name"
        />
      </div>
    </TEDrawerSection>
  );
};
